"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("../styles/styles");
var typestyle = require("typestyle");
var inputBlackClassName = typestyle.style(styles.modal.inputStyleBase, {
    fontSize: '.7rem',
    lineHeight: '.7rem',
    fontFamily: 'sans-serif',
    flex: '1',
});
exports.InputBlack = function (props) {
    return (React.createElement("input", { className: inputBlackClassName, style: props.style, type: "text", placeholder: props.placeholder, value: props.value, onChange: function (e) { return props.onChange(e.target.value); }, onKeyDown: props.onKeyDown }));
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/inputs.js
 ** module id = 396
 ** module chunks = 0
 **/